import React from "react";
import "./CommonDrawer.css";

function CommonDrawer({ open, title, children, onClose }) {
  if (!open) return null;

  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div
        className="drawer"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="drawer-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="drawer-body">
          {children}
        </div>
      </div>
    </div>
  );
}

export default CommonDrawer;
